










import HeaderMenuWinWire from '../HeaderMenu/HeaderMenuWinWire.vue';
import HeaderDirectMessages from './HeaderDirectMessages/HeaderDirectMessages.vue';
import HeaderCommissionBalance from './HeaderCommissionBalance/HeaderCommissionBalance.vue';

export default {
  name: 'HeaderWarRoom',
  components: {
    HeaderCommissionBalance,
    HeaderDirectMessages,
    HeaderMenuWinWire,
  },
};
